import type {
  InvestorInvestmentFundCommitment,
  InvestorInvestmentOverview,
  RawInvestorInvestmentFundCommitment,
  RawInvestorInvestmentOverview,
  RawUnconvertedCLAItem,
  UnconvertedCLAItem,
} from '@/types/investor';
import { toNumber } from '@/utils/number-operations';

function mapUnconvertedCLA(raw: RawUnconvertedCLAItem): UnconvertedCLAItem {
  return {
    portfolio_company_name: raw.portfolio_company_name,
    instrument_type: raw.instrument_type,
    effective_value: toNumber(raw.effective_value),
  };
}

function mapFundCommitment(
  raw: RawInvestorInvestmentFundCommitment
): InvestorInvestmentFundCommitment {
  return {
    id: raw.id,
    name: raw.name,
    commitment: toNumber(raw.commitment),
    drawn: toNumber(raw.drawn),
    undrawn: toNumber(raw.undrawn),
    nav: toNumber(raw.nav),
    fees: toNumber(raw.fees),
    status: raw.status,
    draw_percentage: toNumber(raw.draw_percentage),
    unconverted_cla_exposure: toNumber(raw.unconverted_cla_exposure),
    unconverted_clas: (raw.unconverted_clas ?? []).map(mapUnconvertedCLA),
  };
}

export function mapInvestorInvestmentOverview(
  raw: RawInvestorInvestmentOverview
): InvestorInvestmentOverview {
  return {
    total_commitment: toNumber(raw.total_commitment),
    drawn_capital: toNumber(raw.drawn_capital),
    undrawn_capital: toNumber(raw.undrawn_capital),
    nav: toNumber(raw.nav),
    total_fees: toNumber(raw.total_fees),
    total_unconverted_cla_exposure: toNumber(
      raw.total_unconverted_cla_exposure
    ),
    fund_count: raw.fund_count,
    currency: raw.currency,
    funds: raw.funds.map(mapFundCommitment),
  };
}
